export const productDetailsMultipay = () => ({
  cbx3: {
    type: Object,
    required: false,
    default: null
  },
  cbx4: {
    type: Object,
    required: false,
    default: null
  },
  mensualites: {
    type: Number,
    required: false,
    default: null
  },
  nbMensualites: {
    type: Number,
    required: false,
    default: 0
  },
  frais: {
    type: Number,
    required: false,
    default: null
  }
})